import {Order} from "./order";
import {PlatformProfile} from "./platformprofile";

export class Cart{

  order: Order;
  platformProfile: PlatformProfile

}
